import type { DynamicClient } from '@dynamic-labs-sdk/client';
import { getNetworkProviderBuilderRegistry } from '@dynamic-labs-sdk/client/core';

import { createSuiNetworkProvider } from '../utils/createSuiNetworkProvider';

export const registerSuiNetworkProviderBuilder = (
  client: DynamicClient
): void => {
  const networkProviderBuilderRegistry =
    getNetworkProviderBuilderRegistry(client);

  /**
   * If the Sui network provider builder is already registered, return.
   */
  if (networkProviderBuilderRegistry.get().get('SUI')) {
    return;
  }

  networkProviderBuilderRegistry.register({
    builder: createSuiNetworkProvider,
    chain: 'SUI',
  });
};
